import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { useCustomTheme } from '../../../context/ThemeContext';
import { createStudentTheme } from '../../../theme/studentTheme';
import StudentLayout from './StudentLayout';

/**
 * Wraps student routes in the student-scoped theme (mockup tokens) + top-nav
 * shell. Nested inside the app's global ThemeContextProvider, so it overrides
 * the theme for student surfaces only — Admin/Teacher and the global theme are
 * untouched. Respects the app's light/dark `mode`.
 */
const StudentShell = ({ children }) => {
  const { mode, colorTheme } = useCustomTheme();
  const theme = useMemo(() => createStudentTheme(mode, colorTheme), [mode, colorTheme]);

  return (
    <ThemeProvider theme={theme}>
      <StudentLayout>{children}</StudentLayout>
    </ThemeProvider>
  );
};

export default StudentShell;
